export default __webpack_public_path__ + "static/media/VD6.e725685c.png";